import * as Yup from 'yup';

export const validationSchema = () =>
  Yup.object({
    startDate: Yup.date().required('Required').nullable(),
    frequencyId: Yup.number().required('Required').nullable(),
    intervals: Yup.number().required('Required').nullable(),
    startPeriodNumber: Yup.number().required('Required').nullable(),
  });
